import {
    GET_INFORMASI_JABATAN,
    GET_LIST_PEGAWAI_DRH,
} from 'shared/constants/ActionTypes';

const defaultData = {
    result: []
}

const placeholderDatas = {
    results: []
}

const INIT_STATE = {
    drh: {
        list: { ...placeholderDatas },
        detail: { ...defaultData }
    },
    pegawaiPensiun: { ...defaultData },
    mutasi: { ...defaultData },
    informasiJabatan: { ...defaultData },
    aktivitasOperator: { ...defaultData },
    exportDataPegawai: { ...defaultData },
    persuratan: { ...defaultData },
    pegawaiTugasBelajar: { ...defaultData },
    rekapPegNonPNS: { ...defaultData },
    pegPerbaikan: { ...defaultData }
};

const laporanKhususReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_PEGAWAI_DRH: {
            return {
                ...state,
                drh: {
                    ...state.drh,
                    list: action.payload
                }
            }
        }
        case GET_INFORMASI_JABATAN: {
            return {
                ...state,
                informasiJabatan: action.payload
            }
        }
        default:
            return state;
    }
};
export default laporanKhususReducer;
